import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import TextInput from '../../social-stack-web/src/components/TextInput';
import { isNullOrEmpty } from '../../shared/utils/Helpers';
import CustomButton from '../../social-stack-web/src/components/CustomButton';
import styles from '../../social-stack-web/src/components/registration/Registration.module.css'
import  {userProfile} from '../../shared/models/UserProfile'
import { projectConfig } from '../../shared/project-info/projectConfig';
import registerProfileFlow from '../utils/RegisterProfileFlow';

class RegisterMilitaryService extends Component {
    constructor() {
        super();
        this.state = {
            user_role: "",
            user_role_error: "",
        };
    }
    nextPressed = () => {
        const {
            user_role
        } = this.state;
        const { location } = this.props
        const field_is_required_string = 'THIS FIELD IS REQUIRED';

        let hasError = false;

        if (isNullOrEmpty(user_role)) {
            this.setState({ user_role_error: field_is_required_string });
            hasError = true;
        }
        if (hasError) return;
        let value = location.state?.value

        value = Object.assign(
            value,
            {
                extra_info: {
                    industry: user_role
                }
            }
        );
        const profile = Object.assign({}, userProfile.getUserProfile(), value);
        userProfile.saveToUserProfile(profile);
        let incomplete = false;
        if (location.state.incomplete) incomplete = true;
        const nextStep = registerProfileFlow.getNextScreen(this.props.currentPath);
        this.props.history.push({
            pathname: `/registration/${nextStep.path}`,
            state: {
                value: profile,
                incomplete
            }
        })
    }
    render() {

        const stepText = registerProfileFlow.getStepText(this.props.currentPath);
        const prevStep = registerProfileFlow.getPreviousScreen(this.props.currentPath);

        return (
            <div className={styles.container}>
                <div className={styles.headerContainer}>
                    <h3 className="title">{projectConfig.profileInfoTitle}</h3>
                    <p className="titleSubheader">{stepText}</p>
                </div>
                <div className={styles.contentContainer}>
                    <div>
                        <TextInput
                            label={'TEAM, ROLE OR TITLE'}
                            type={''}
                            error={this.state.user_role_error}
                            value={this.state.user_role}
                            onValueChange={(text) => this.setState({
                                user_role: text.target.value
                            })}
                        />
                        <p>
                            e.g Analyst, Marketing, Sales, etc
                        </p>
                    </div>
                    <div className={styles.buttonContainer}>
                        <CustomButton
                            onClick={this.nextPressed}
                            label={'Next'}
                            buttonStyle={'primary'}
                        />
                        {
                            prevStep && (
                                <CustomButton
                                link={true}
                                to={`/registration/${prevStep.path}`}
                                label={'Back'}
                                buttonStyle={'secondary'}
                                />
                            )
                        }
                    </div>


                </div>

            </div>
        )
    }
}

export default withRouter(RegisterMilitaryService)